import { Pill, type PillSize } from "@src/appV2/redesign/system/ui-components";
import pluralize from "pluralize";

import { APP_V2_USER_EVENTS } from "../../../../lib/analytics";
import { useLogEffect } from "../../../../lib/analytics/useLogEffect";

interface PostBookingDocumentsPillProps {
  count: number;
  shiftId: string;
  size?: PillSize;
}

export function PostBookingDocumentsPill(props: PostBookingDocumentsPillProps) {
  const { count, shiftId, size = "small" } = props;

  useLogEffect(
    APP_V2_USER_EVENTS.POST_BOOKING_DOCUMENTS_BOOKING_CARD_PILL_SHOWN,
    {
      shiftId,
      count,
    },
    { enabled: count > 0 }
  );

  if (count === 0) {
    return null;
  }

  return (
    <Pill
      size={size}
      label={`${count} ${pluralize("Document", count)} Needed`}
      backgroundColor={(theme) => theme.palette.intent?.warning.background}
      color={(theme) => theme.palette.intent?.warning.text}
    />
  );
}
